/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiBaseAlertStatusListConf
 */
export interface InternalApiBaseAlertStatusListConf {
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiBaseAlertStatusListConf
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof InternalApiBaseAlertStatusListConf
     */
    sortOrder?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiBaseAlertStatusListConf
     */
    restrictedTo?: Array<string>;
}

/**
 * Check if a given object implements the InternalApiBaseAlertStatusListConf interface.
 */
export function instanceOfInternalApiBaseAlertStatusListConf(value: object): value is InternalApiBaseAlertStatusListConf {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function InternalApiBaseAlertStatusListConfFromJSON(json: any): InternalApiBaseAlertStatusListConf {
    return InternalApiBaseAlertStatusListConfFromJSONTyped(json, false);
}

export function InternalApiBaseAlertStatusListConfFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBaseAlertStatusListConf {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'restrictedTo': json['restrictedTo'] == null ? undefined : json['restrictedTo'],
    };
}

export function InternalApiBaseAlertStatusListConfToJSON(json: any): InternalApiBaseAlertStatusListConf {
    return InternalApiBaseAlertStatusListConfToJSONTyped(json, false);
}

export function InternalApiBaseAlertStatusListConfToJSONTyped(value?: InternalApiBaseAlertStatusListConf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
        'restrictedTo': value['restrictedTo'],
    };
}

